import {Chart} from 'chart.js';

(function ($) {
  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });
  $('.switcher.collapsed').each(function () {
    let id = '#' + $(this).data('switch');
    $(id).hide();
  });
  $('.switcher').on('click', function () {
    let $this = $(this);
    let id = '#' + $this.data('switch');
    $(id).toggle();
    if ($this.hasClass('collapsed')) {
      $this.removeClass('collapsed').addClass('opened');
    }
    else {
      $this.removeClass('opened').addClass('collapsed');
    }
  });
  $('.toggle-master').on('change', function () {
    let target_id = $(this).data('target_id');
    if (target_id) {
      let $el = $('#' + target_id);
      $(this).is(':checked') ? $el.show() : $el.hide();
    }
  });
})(jQuery);
window.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.btn-download').forEach(function (el) {
    el.addEventListener('click', (event) => {
      let target = el.dataset.target;
      let content = document.getElementById(target).value;
      if (!content.length) {
        return;
      }
      content = content.replace(/\n/g, '\r\n'); // To retain the Line breaks.
      let blob = new Blob([content], {type: 'application/json'});
      let anchor = document.createElement('a');

      anchor.download = el.dataset.filename;
      anchor.href = window.URL.createObjectURL(blob);
      anchor.target = '_blank';
      anchor.style.display = 'none'; // just to be safe!
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    });
  });
});
